export default __webpack_public_path__ + "c17318442e986eca08106c96ebe60dc6.png";